// extracted by mini-css-extract-plugin
module.exports = {"w55Percent":"Styles_w55Percent__e82R4","linkStyle":"Styles_linkStyle__3tI8b","middleAlign":"Styles_middleAlign__yQvnG"};